import { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import '../styles/Sidebar.css';

export const Topbar = () => {
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
        const handleResize = () => {
            const mobile = window.innerWidth <= 768;
            setIsMobile(mobile);
            if (!mobile) setIsOpen(false); 
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <nav className="topbar">
            {isMobile && (
                <div className="topbar-header">
                    <button className="hamburger" onClick={() => setIsOpen(!isOpen)}>
                        &#9776;
                    </button>
                </div>
            )}

            <ul className={`topbar-menu ${isMobile && isOpen ? 'open' : ''}`}>
                <li>
                    <NavLink
                        to="/panel/dashboard"
                        className={({ isActive }) => (isActive ? 'active' : '')}
                        onClick={() => isMobile && setIsOpen(false)}
                    >
                        Dashboard
                    </NavLink>
                </li>
                <li>
                    <NavLink
                        to="/panel/timesheet"
                        className={({ isActive }) => (isActive ? 'active' : '')}
                        onClick={() => isMobile && setIsOpen(false)}
                    >
                        Timesheet
                    </NavLink>
                </li>
                <li>
                    <NavLink
                        to="/panel/leaves"
                        className={({ isActive }) => (isActive ? 'active' : '')}
                        onClick={() => isMobile && setIsOpen(false)}
                    >
                        Leaves
                    </NavLink>
                </li>
            </ul>
        </nav>
    );
};
